import { IonPage } from '@ionic/react'
import { useParams } from 'react-router-dom'

import { useGetUnitGenericDetails } from '@apps-common/apis/portal/unit'
import {
  UnitDetailsManagement,
  UnitDetailsManagementHeaderOptions
} from '@apps-common/apps/portal/pages/units/pages/manage/pages/details/components/management'
import { PullRefresh, UnauthorizedCard } from '@apps-common/components/common'
import { AccountNoTitle, PageTitle } from '@apps-common/components/common/portal-title'
import { Header, LayoutContainer, LayoutPadding } from '@apps-common/components/layout'
import { Breadcrumbs, Navbar } from '@apps-common/components/navigation'
import { valueIsValidCheck } from '@apps-common/helpers/value-string-check'
import { AUTH_CLAIMS, Authorization } from '@apps-common/lib'
import { ROUTE_CREATE_UNIT, ROUTE_UNIT_DETAILS } from '@apps-radionet-portal/config/private-routes'

export const UnitDetailsPage: React.FC = () => {
  const { status, unitId } = useParams<{ status: string; unitId: string }>()
  const {
    data: unit,
    isLoading: unitIsLoading,
    isError: unitIsError,
    refetch
  } = useGetUnitGenericDetails({
    config: {
      enabled: valueIsValidCheck(unitId)
    },
    status,
    unitId
  })

  const loading = !!unitId && (unitIsLoading || unitIsError)

  return (
    <IonPage>
      <Authorization
        roles={AUTH_CLAIMS.managementAdmin.roles}
        scopes={AUTH_CLAIMS.managementAdmin.scopes}
        notAuthorizedFallback={<UnauthorizedCard />}
      >
        <>
          <Header>
            <Navbar showBack transparent />
            <Breadcrumbs route={unitId ? ROUTE_UNIT_DETAILS : ROUTE_CREATE_UNIT} />
            <div className='flex items-center justify-between max-w-[1200px]'>
              <PageTitle classes='flex items-center justify-start gap-[10px]'>
                {unitId && <span className='capitalize'>Device details</span>}
                {!unitId && <span>Create Device</span>}
                {unitId && unit && <AccountNoTitle text={`(Acc# ${unit.accountNo})`} />}
              </PageTitle>
              <UnitDetailsManagementHeaderOptions loading={loading} unit={unit} />
            </div>
          </Header>
          <LayoutContainer>
            {!unitId && <PullRefresh loading={loading} callback={refetch} />}
            <LayoutPadding>
              <UnitDetailsManagement loading={loading} unit={unit} />
            </LayoutPadding>
          </LayoutContainer>
        </>
      </Authorization>
    </IonPage>
  )
}
